export default {
	"coupon.ThereAreNoCoupons": "There are no coupons",
	"coupon.Loading": "Loading...",
	"coupon.NoMore": "No more~"
}